<footer class="navbar-fixed-bottom" ng-hide="hideNavBar">
    <div class="gototop" style="display: none;">
        <button class="btn btn-primary" ng-click="scrollToTop()"><i class="glyphicon ng-scope glyphicon-chevron-up"></i><br>TOP</button>
    </div>
    <ul>
        <li class="navbar-fixed-bottom">
          <span class="pull-left small">&copy; {{currentYear}} Deloitte Assurance. &reg; All rights reserved.</span>
            <span class="pull-right small hidden-xs hidden-sm">Member of Deloitte Touche Tohmatsu Limited (DTTL)  | <a target="_blank" href="https://cookienotice.deloitte.com">Cookies</a> | <a class="optanon-toggle-display">Cookie Settings</a></span>
        </li>
    </ul>
</footer>
